<template>
  <jz-container class="recent-exercises-card" v-if="hasRecentExercises">
    <jz-container class="section-header">
      {{ "dashboard.recentExercises.title" | __ }}
    </jz-container>
    <jz-container class="container recent-exercises-container">
      <learning-history-exercise-log
        class="container-item"
        v-for="(log, index) in recentExercises"
        :key="index"
        :log="log"
        @click.native="goToExerciseFromLog(log)"
      />
    </jz-container>
  </jz-container>
</template>

<script>
import {
  VUEX_LEARNING_HISTORY_ACTION_NAMES,
  VUEX_LEARNING_HISTORY_NAMESPACE
} from "@tt-app/constants";
import GoToExerciseMixin from "@tt-app/components/exercise/mixins/GoToExerciseMixin";
const { RECENT_EXERCISES_REQUEST } = VUEX_LEARNING_HISTORY_ACTION_NAMES;
import bookIcon from "@joyz/app-core/assets/icons/default/Book.svg";
import LearningHistoryExerciseLog from "@tt-app/components/learningHistory/LearningHistoryExerciseLog";

export default {
  name: "RecentExercisesList",
  components: { LearningHistoryExerciseLog },
  mixins: [GoToExerciseMixin],
  computed: {
    recentExercises() {
      return this.$store.getters[`${VUEX_LEARNING_HISTORY_NAMESPACE}/recentExercises`];
    },
    hasRecentExercises() {
      return this.recentExercises && this.recentExercises.length > 0;
    }
  },
  created() {
    this.bookIcon = bookIcon;
    this.fetchRecentExercises();
  },
  methods: {
    async fetchRecentExercises() {
      await this.$store.dispatch(
        `${VUEX_LEARNING_HISTORY_NAMESPACE}/${RECENT_EXERCISES_REQUEST}`,
        {}
      );
    }
  }
};
</script>

<style lang="scss">
.recent-exercises-container {
  white-space: nowrap;
  overflow-x: auto;
  display: flex;

  .learning-history-exercise-log {
    background-color: white;
    width: 340px;
    min-width: 340px;
    height: 69px;
    margin: $gutter/2;
    cursor: pointer;
    border-bottom: 1px solid rgba(var(--rgb-black), 0.08);
    border-top: unset;
  }
}

@include responsive(phone) {
  .recent-exercises-container {
    .learning-history-exercise-log {
      min-width: 100%;
    }
  }
}

// for displays with less width than desktop
@media only screen and (max-width: $min-desktop-width - 1) {
  .recent-exercises-container {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .recent-exercises-container::-webkit-scrollbar {
    display: none;
  }
}
</style>
